// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  height: 100vh;
  padding: 0 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.app .addHome {
  padding: 10px;
  margin-top: 20px;
  cursor: pointer;
  border: none;
  background-color: teal;
  color: white;
  font-weight: bold;
}
.app h1 {
  margin-bottom: 50px;
}
.app .books {
  display: flex;
}
.app .books .book {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.app .books .book img {
  width: 200px;
  height: 300px;
  object-fit: cover;
}
.app .books .book button {
  padding: 3px 6px;
  background-color: white;
  cursor: pointer;
}
.app .books .book .delete {
  border: 1px solid rgb(245, 191, 191);
  color: rgb(242, 100, 100);
}
.app .books .book .update {
  border: 1px solid rgb(204, 204, 243);
  color: rgb(139, 139, 234);
}
.app .form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.app .form input {
  width: 250px;
  padding: 10px;
  border: 1px solid gray;
}
.app .form textarea {
  padding: 10px;
}
.app .form button {
  border: none;
  padding: 10px;
  background-color: white;
  background-color: teal;
  color: white;
  font-weight: bold;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/add.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,aAAA;AADN;AAGM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADR;AAGQ;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AADV;AAIQ;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AAFV;AAIQ;EACE,oCAAA;EACA,yBAAA;AAFV;AAIQ;EACE,oCAAA;EACA,yBAAA;AAFV;AAOI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALN;AAOM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AALR;AAQM;EACE,aAAA;AANR;AASM;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAPR","sourcesContent":[".app {\n    height: 100vh;\n    padding: 0 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  \n    .addHome {\n      padding: 10px;\n      margin-top: 20px;\n      cursor: pointer;\n      border: none;\n      background-color: teal;\n      color: white;\n      font-weight: bold;\n    }\n  \n    h1 {\n      margin-bottom: 50px;\n    }\n  \n    .books {\n      display: flex;\n  \n      .book {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 10px;\n  \n        img {\n          width: 200px;\n          height: 300px;\n          object-fit: cover;\n        }\n  \n        button {\n          padding: 3px 6px;\n          background-color: white;\n          cursor: pointer;\n        }\n        .delete {\n          border: 1px solid rgb(245, 191, 191);\n          color: rgb(242, 100, 100);\n        }\n        .update {\n          border: 1px solid rgb(204, 204, 243);\n          color: rgb(139, 139, 234);\n        }\n      }\n    }\n  \n    .form {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n  \n      input {\n        width: 250px;\n        padding: 10px;\n        border: 1px solid gray;\n      }\n  \n      textarea {\n        padding: 10px;\n      }\n  \n      button {\n        border: none;\n        padding: 10px;\n        background-color: white;\n        background-color: teal;\n        color: white;\n        font-weight: bold;\n        cursor: pointer;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
